import React from 'react'

import clsx from 'clsx'

import CheckmarkIcon from '$extensionSrc/icons/checkmark-icon.svg'
import { isNotEmpty } from '$extensionSrc/utils/stringValidator'

import './FormTextInput.scss'

interface Requirement {
  text: string
  isFulfilled: boolean
}

export default function FormTextInput({
  additionalClassNames,
  disabled,
  handleChange,
  isSensitive,
  name,
  placeholderText,
  requirements,
  value,
  infoText,
}: {
  additionalClassNames?: string
  disabled?: boolean
  handleChange: (any) => void
  isSensitive: boolean
  name: string
  placeholderText: string
  requirements?: Requirement[]
  value: string
  infoText?: string
}) {
  const [inFocus, setInFocus] = React.useState(false)

  const handleInputChange = (event) => {
    handleChange(event.target.value)
  }
  const handleFocus = () => setInFocus(true)
  const handleBlur = () => setInFocus(false)

  const isEmpty = !isNotEmpty(value)

  let hintsElements

  if (requirements) {
    hintsElements = requirements.map((req) => {
      const hintIcon = req.isFulfilled ? (
        <div className="hint-icon">
          <CheckmarkIcon aria-hidden className="fulfilled" />
        </div>
      ) : (
        <div className="hint-icon dot" />
      )

      return (
        <div className="hint-row" key={req.text}>
          {hintIcon}
          <div className="hint-text">{req.text}</div>
        </div>
      )
    })
  }

  const labelClassStr = clsx(
    'body3',
    isEmpty && 'hidden',
    inFocus && 'selected',
    disabled && 'disabled',
  )
  const inputClassStr = clsx('body1', !isEmpty && 'filled')

  const showHints = (infoText && !inFocus) || !infoText

  const hintClassStr = clsx(
    'body3',
    'hint',
    (isEmpty || !showHints) && 'hidden',
  )

  const infoTextClassStr = clsx('body3', 'info-text', isEmpty && 'hidden')

  return (
    <div className={clsx('FormTextInput', additionalClassNames)}>
      <label htmlFor={name} className={labelClassStr}>
        {placeholderText}
      </label>
      <input
        id={name}
        className={inputClassStr}
        disabled={disabled}
        name={name}
        onBlur={handleBlur}
        onChange={handleInputChange}
        onFocus={handleFocus}
        placeholder={placeholderText}
        type={isSensitive ? 'password' : 'text'}
        value={value}
      />
      {infoText && <div className={infoTextClassStr}>{infoText}</div>}
      <div className={hintClassStr}>{hintsElements}</div>
    </div>
  )
}
